import { Box, Button, Grid, useMediaQuery } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import "./Quiz.css";
import * as FirestoreService from "../../utils/firestoreQuery";

//assets
import Logo from "../../assets/logo_quick-learning-tool.png";
import IntroBg from "../../assets/loan-interactive/IntroBg.png";

import defaultImage from "../../assets/loan-interactive/default.png";

import gif1 from "../../assets/loan-interactive/vendor-01.gif";
import gif2 from "../../assets/loan-interactive/vendor-02.gif";
import gif3 from "../../assets/loan-interactive/vendor-03.gif";
import gif4 from "../../assets/loan-interactive/vendor-04.gif";
import gif5 from "../../assets/loan-interactive/vendor-05.gif";

import gif1Done from "../../assets/loan-interactive/vendor-01_still.jpg";
import gif2Done from "../../assets/loan-interactive/vendor-02_still.jpg";
import gif3Done from "../../assets/loan-interactive/vendor-03_still.jpg";
import gif4Done from "../../assets/loan-interactive/vendor-04_still.jpg";
import gif5Done from "../../assets/loan-interactive/vendor-05_still.jpg";

import closeUpBg1 from "../../assets/loan-interactive/closeUpBg/vendor-01_close-up.png";
import closeUpBg2 from "../../assets/loan-interactive/closeUpBg/vendor-02_close-up.png";
import closeUpBg3 from "../../assets/loan-interactive/closeUpBg/vendor-03_close-up.png";
import closeUpBg4 from "../../assets/loan-interactive/closeUpBg/vendor-04_close-up.png";
import closeUpBg5 from "../../assets/loan-interactive/closeUpBg/vendor-05_close-up.png";

import step1PlayButton from "../../assets/loan-interactive/Vendor Labels/manang-dang_play.png";
import step1PlayButtonDome from "../../assets/loan-interactive/Vendor Labels/manang-dang_done.png";
import step2PlayButton from "../../assets/loan-interactive/Vendor Labels/mareng-risa_play.png";
import step2PlayButtonDome from "../../assets/loan-interactive/Vendor Labels/mareng-risa_done.png";
import step3PlayButton from "../../assets/loan-interactive/Vendor Labels/madam-burda_play.png";
import step3PlayButtonDome from "../../assets/loan-interactive/Vendor Labels/madam-burda_done.png";
import step4PlayButton from "../../assets/loan-interactive/Vendor Labels/ate-pan_play.png";
import step4PlayButtonDome from "../../assets/loan-interactive/Vendor Labels/ate-pan_done.png";
import step5PlayButton from "../../assets/loan-interactive/Vendor Labels/kuya-pau_play.png";
import step5PlayButtonDome from "../../assets/loan-interactive/Vendor Labels/kuya-pau_done.png";
import toastError from "../../assets/loan-interactive/toast-message-02.png";
import outroBg from "../../assets/loan-interactive/flowing-cape.gif";
import startButton from "../../assets/loan-interactive/start-button.png";
import restartButton from "../../assets/loan-interactive/restart-button.png";

// components
import Vendor1 from "./vendors/Vendor1";
import Vendor2 from "./vendors/Vendor2";
import Vendor3 from "./vendors/Vendor3";
import Vendor4 from "./vendors/Vendor4";
import Vendor5 from "./vendors/Vendor5";
import Intro from "./vendors/Intro";
import Closing from "./vendors/Closing";
//icon
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import ProgressContext from "../../utils/context";
import InsEN from "./instruction/English-Instruction";
import InsPH from "./instruction/FIl-Instruction";

import startImg from "../../assets/loan-interactive/play.png";

import { useNavigate } from "react-router-dom";

const useProgressiveImage = (src) => {
  const [sourceLoaded, setSourceLoaded] = useState(null);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => setSourceLoaded(src);
  }, [src]);

  return sourceLoaded;
};

function Quiz() {
  const md = useMediaQuery("(min-width:900px)", { noSsr: true });
  const xs = useMediaQuery("(max-width:600px)", { noSsr: true });
  const [objData, setObjData] = useState(null);
  const [welcomeClicked, setWelcomeClicked] = useState(false);
  const [showIntro, setShowIntro] = useState(false);
  const [pathName, setPathName] = useState("");
  const [bgImage, setBgImage] = useState(null);
  const [pageLang, setPageLang] = useState("");
  const { progress, showOutro } = useContext(ProgressContext);
  const navigate = useNavigate();

  const [steps, setSteps] = useState({
    one: false,
    oneShow: false,
    two: false,
    twoShow: false,
    three: false,
    threeShow: false,
    four: false,
    fourShow: false,
    five: false,
    fiveShow: false,
  });

  const loaded = useProgressiveImage(bgImage);

  useEffect(() => {
    if (window.location.pathname === "/en") {
      setPageLang("en");
    } else {
      setPageLang("ph");
    }
  }, []);

  useEffect(() => {
    setObjData(null);
    if (pageLang === "en") {
      FirestoreService.getLoanVar().onSnapshot((doc) => {
        setObjData(doc.data());
      });
    } else {
      FirestoreService.getLoanFilVar().onSnapshot((doc) => {
        setObjData(doc.data());
      });
    }
  }, [pageLang]);

  useEffect(() => {
    if (welcomeClicked) {
      setBgImage(defaultImage);
    } else {
      setBgImage(null);
    }
  }, [welcomeClicked]);

  const handleSelectedPerson = (personNumber) => {
    if (personNumber === 1 && steps.one === true) {
      setSteps((prev) => ({ ...prev, oneShow: true }));
      setBgImage(closeUpBg1);
      return;
    }
    if (personNumber === 2 && steps.two === true) {
      setSteps((prev) => ({ ...prev, twoShow: true }));
      setBgImage(closeUpBg2);
      return;
    }
    if (personNumber === 3 && steps.three === true) {
      setSteps((prev) => ({ ...prev, threeShow: true }));
      setBgImage(closeUpBg3);
      return;
    }
    if (personNumber === 4 && steps.four === true) {
      setSteps((prev) => ({ ...prev, fourShow: true }));
      setBgImage(closeUpBg4);
      return;
    }
    if (personNumber === 5 && steps.five === true) {
      setSteps((prev) => ({ ...prev, fiveShow: true }));
      setBgImage(closeUpBg5);
      return;
    }

    // ERROR
    if (personNumber === 2 && steps.one === false) {
      setSteps((prev) => ({ ...prev, oneError: true }));
    }
    if (personNumber === 3 && steps.two === false) {
      setSteps((prev) => ({ ...prev, twoError: true }));
    }
    if (personNumber === 4 && steps.three === false) {
      setSteps((prev) => ({ ...prev, threeError: true }));
    }
    if (personNumber === 5 && steps.four === false) {
      setSteps((prev) => ({ ...prev, fourError: true }));
    }

    // FIRST OPEN

    if (personNumber === 1 && steps.one === false) {
      setBgImage(gif1);
      const delayedCodeExecution = () => {
        setSteps((prev) => ({ ...prev, one: true }));
        setSteps((prev) => ({
          ...prev,
          oneShow: true,
          twoError: false,
          ["isDone" + [personNumber]]: true,
        }));
        setBgImage(closeUpBg1);
      };
      const timeoutId = setTimeout(delayedCodeExecution, 2000);

      return () => clearTimeout(timeoutId);
    }

    if (personNumber === 2 && steps.one === true && steps.isDone2 !== true) {
      setBgImage(gif2);
      const delayedCodeExecution = () => {
        setSteps((prev) => ({ ...prev, two: true }));
        setSteps((prev) => ({
          ...prev,
          twoShow: true,
          threeError: false,
          ["isDone" + [personNumber]]: true,
        }));
        setBgImage(closeUpBg2);
      };
      const timeoutId = setTimeout(delayedCodeExecution, 2000);
      return () => clearTimeout(timeoutId);
    }
    if (personNumber === 3 && steps.two === true && steps.isDone3 !== true) {
      setBgImage(gif3);
      const delayedCodeExecution = () => {
        setSteps((prev) => ({ ...prev, three: true }));
        setSteps((prev) => ({
          ...prev,
          threeShow: true,
          fourError: false,
          ["isDone" + [personNumber]]: true,
        }));
        setBgImage(closeUpBg3);
      };
      const timeoutId = setTimeout(delayedCodeExecution, 3000);
      return () => clearTimeout(timeoutId);
    }
    if (personNumber === 4 && steps.three === true) {
      setBgImage(gif4);
      const delayedCodeExecution = () => {
        setSteps((prev) => ({ ...prev, four: true }));
        setSteps((prev) => ({
          ...prev,
          fourShow: true,
          fiveError: false,
          ["isDone" + [personNumber]]: true,
        }));
        setBgImage(closeUpBg4);
      };
      const timeoutId = setTimeout(delayedCodeExecution, 3000);
      return () => clearTimeout(timeoutId);
    }
    if (personNumber === 5 && steps.four === true) {
      setBgImage(gif5);

      const delayedCodeExecution = () => {
        setSteps((prev) => ({ ...prev, five: true }));
        setSteps((prev) => ({
          ...prev,
          fiveShow: true,
          ["isDone" + [personNumber]]: true,
        }));
        setBgImage(closeUpBg5);
      };
      const timeoutId = setTimeout(delayedCodeExecution, 3000);
      return () => clearTimeout(timeoutId);
    }
  };

  const handleChildHideCloseUp = (vendor) => {
    setSteps((prev) => ({ ...prev, [vendor]: false }));

    let lastTrueField = null;

    for (const step in steps) {
      if (
        steps.hasOwnProperty(step) &&
        step.startsWith("isDone") &&
        steps[step]
      ) {
        lastTrueField = step;
      }
    }

    if (lastTrueField === "isDone1") {
      setBgImage(gif1Done);
      return;
    }
    if (lastTrueField === "isDone2") {
      setBgImage(gif2Done);
      return;
    }

    if (lastTrueField === "isDone3") {
      setBgImage(gif3Done);
      return;
    }

    if (lastTrueField === "isDone4") {
      setBgImage(gif4Done);
      return;
    }

    if (lastTrueField === "isDone5") {
      setBgImage(gif5Done);
      return;
    }

    if (vendor === "oneShow") {
      setBgImage(gif1);
    }
    if (vendor === "twoShow") {
      setBgImage(gif2);
    }
    if (vendor === "threeShow") {
      setBgImage(gif3);
    }
    if (vendor === "fourShow") {
      setBgImage(gif4);
    }
    if (vendor === "fiveShow") {
      setBgImage(gif5);
    }
  };

  const buttonGoMarketElement = (
    <div
      style={{
        marginTop: ".5rem",
        cursor: "pointer",
        marginBottom: ".5rem",
        float: "right",
        backgroundColor: "#1cc4ec",
        padding: "1rem",
        borderRadius: "2rem",
        color: "white",
      }}
      onClick={() => setWelcomeClicked(true)}
    >
      <b>
        {pageLang === "en" ? <>Go to market </> : <>Pumunta ng Palengke </>}
        <ArrowForwardRoundedIcon
          sx={{
            width: "1.8rem",
            height: "2rem",
            marginTop: "-1.67rem",
            marginBottom: "-.5rem",
            marginLeft: ".2rem",
          }}
        />
      </b>
    </div>
  );

  return (
    <Box>
      <Grid container>
        <Grid item xs={12} md={4.2} className="left-card">
          <Box className="img-container">
            <img src={Logo} alt="Logo" className="logo-img" />
          </Box>
          <Box className="instruction-card">
            <div
              style={{
                paddingLeft: md ? "5rem" : "2rem",
                paddingRight: md ? "5rem" : "2rem",
              }}
            >
              <Box className="instruction-text-container">
                {pageLang === "en" ? <InsEN /> : <InsPH />}
              </Box>
            </div>

            <Grid
              container
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              {showIntro === false && (
                <>
                  <Button
                    className="left-button"
                    onClick={() => {
                      setPageLang("en");
                      navigate("/en");
                      setShowIntro(true);
                    }}
                  >
                    <img
                      src={startImg}
                      alt="Start"
                      style={{ marginRight: "11px", width: "1rem" }}
                    />
                    Start (English)
                  </Button>

                  <Button
                    className="left-button-outlined"
                    onClick={() => {
                      setPageLang("ph");
                      navigate("/ph");
                      setShowIntro(true);
                    }}
                  >
                    <img
                      src={startImg}
                      alt="Start"
                      style={{ marginRight: "11px", width: "1rem" }}
                    />
                    Start (Filipino)
                  </Button>
                </>
              )}

              {showOutro && (
                <>
                  <img
                    onClick={() => {
                      window.location.reload();
                    }}
                    src={restartButton}
                    alt="restart"
                    style={{
                      cursor: "pointer",
                      marginTop: "3rem",
                      height: "4rem",
                    }}
                  />
                  <div
                    style={{
                      marginTop: "1rem",
                      fontWeight: "600",
                      fontSize: ".85rem",
                      color: "#06bcee",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      (window.location.href =
                        "https://www.aralplus.ph/quick-learning-tools")
                    }
                  >
                    Back to Quick Learning Tools
                  </div>
                </>
              )}
            </Grid>
          </Box>
        </Grid>

        {welcomeClicked ? (
          <>
            {showOutro ? (
              <Grid
                item
                xs={12}
                md={7.8}
                className="right-card"
                sx={{ maxHeight: md && "100vh" }}
              >
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <img
                    src={outroBg}
                    style={{
                      display: "block",
                      width: "100%",
                      height: md ? "100vh" : "auto",
                      objectFit: "fill",
                    }}
                    alt="image"
                  />
                  <Box
                    sx={{
                      position: md ? "absolute" : "absolute",
                      top: md ? "0%" : "14%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: md ? "center" : "left",
                      flexDirection: "column",
                      paddingTop: "5%",
                      paddingLeft: "1rem",
                    }}
                  >
                    <div
                      style={{
                        color: "white",
                        fontSize: md ? "3rem" : "1.5rem",
                      }}
                    >
                      {" "}
                      <b>Congrats!</b>
                    </div>
                    <div
                      style={{ color: "white", fontSize: md ? "2rem" : "1rem" }}
                    >
                      {pageLang === "en"
                        ? "You just finished this learning tool."
                        : "Natapos mo na ang learning tool na ito."}
                    </div>
                  </Box>
                  <Closing objData={objData?.zClosing} />
                </div>
              </Grid>
            ) : (
              <Grid
                item
                xs={12}
                md={7.8}
                className="right-card"
                sx={{
                  // backgroundImage: `url(${loaded || bgImage})`,
                  backgroundColor: "#afdd83",
                  maxHeight: md && "100vh",
                }}
              >
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <img
                    src={loaded || bgImage}
                    style={{
                      display: "block",
                      width: "100%",
                      height: md ? "100vh" : "auto",
                      objectFit: "fill",
                    }}
                    alt="image"
                  />

                  {steps.oneShow === false &&
                    steps.twoShow === false &&
                    steps.threeShow === false &&
                    steps.fourShow === false &&
                    steps.fiveShow === false && (
                      <Grid container>
                        <Box
                          onClick={() => handleSelectedPerson(1)}
                          className="exclaButton1 bounceExcla"
                        >
                          {steps.one === false && steps.oneError == true && (
                            <img
                              src={toastError}
                              alt="Logo"
                              style={{
                                width: xs ? "120px" : "180px",
                                marginLeft: xs ? "-40px" : "-60px",
                                marginBottom: xs ? "-20px" : "-20px",
                                marginTop: "-1000px",
                              }}
                            />
                          )}
                          <Box>
                            {steps.one === true ? (
                              <img
                                src={step1PlayButtonDome}
                                alt="Logo"
                                className={
                                  xs ? "exclaImageExtraSmall" : "exclaImage"
                                }
                              />
                            ) : (
                              <img
                                src={step1PlayButton}
                                alt="Logo"
                                className={
                                  xs ? "exclaImageExtraSmall" : "exclaImage"
                                }
                              />
                            )}
                          </Box>
                        </Box>

                        <Box
                          onClick={() => handleSelectedPerson(2)}
                          className="exclaButton2 bounceExcla"
                        >
                          {steps.one == true &&
                            steps.two === false &&
                            steps.twoError == true && (
                              <img
                                src={toastError}
                                alt="Logo"
                                style={{
                                  width: xs ? "120px" : "180px",
                                  marginLeft: xs ? "15px" : "25px",
                                  marginBottom: xs ? "-20px" : "-20px",
                                  marginTop: "-1000px",
                                }}
                              />
                            )}
                          <Box>
                            {steps.two === true ? (
                              <img
                                src={step2PlayButtonDome}
                                alt="Logo"
                                className={
                                  xs ? "exclaImageExtraSmall" : "exclaImage"
                                }
                              />
                            ) : (
                              <img
                                src={step2PlayButton}
                                alt="Logo"
                                className={
                                  xs ? "exclaImageExtraSmall" : "exclaImage"
                                }
                              />
                            )}
                          </Box>
                        </Box>

                        <Box
                          onClick={() => handleSelectedPerson(3)}
                          className="exclaButton3 bounceExcla"
                        >
                          {steps.two == true &&
                            steps.three === false &&
                            steps.threeError == true && (
                              <img
                                src={toastError}
                                alt="Logo"
                                style={{
                                  width: xs ? "120px" : "180px",
                                  marginLeft: xs ? "-39px" : "-58px",
                                  marginBottom: xs ? "-20px" : "-20px",
                                  marginTop: "-1000px",
                                }}
                              />
                            )}
                          <Box>
                            {steps.three === true ? (
                              <img
                                src={step3PlayButtonDome}
                                alt="Logo"
                                className={
                                  xs ? "exclaImageExtraSmall" : "exclaImage"
                                }
                              />
                            ) : (
                              <img
                                src={step3PlayButton}
                                alt="Logo"
                                className={
                                  xs ? "exclaImageExtraSmall" : "exclaImage"
                                }
                              />
                            )}
                          </Box>
                        </Box>

                        <Box
                          onClick={() => handleSelectedPerson(4)}
                          className="exclaButton4 bounceExcla"
                        >
                          {steps.three == true &&
                            steps.four === false &&
                            steps.fourError == true && (
                              <img
                                src={toastError}
                                alt="Logo"
                                style={{
                                  width: xs ? "120px" : "180px",
                                  marginLeft: xs ? "16px" : "20px",
                                  marginBottom: xs ? "-20px" : "-20px",
                                  marginTop: "-1000px",
                                }}
                              />
                            )}
                          <Box>
                            {steps.four === true ? (
                              <img
                                src={step4PlayButtonDome}
                                alt="Logo"
                                className={
                                  xs ? "exclaImageExtraSmall" : "exclaImage"
                                }
                              />
                            ) : (
                              <img
                                src={step4PlayButton}
                                alt="Logo"
                                className={
                                  xs ? "exclaImageExtraSmall" : "exclaImage"
                                }
                              />
                            )}
                          </Box>
                        </Box>

                        <Box
                          onClick={() => handleSelectedPerson(5)}
                          className="exclaButton5 bounceExcla"
                        >
                          <Box>
                            {steps.five === true && progress === 100 ? (
                              <img
                                src={step5PlayButtonDome}
                                alt="Logo"
                                className={
                                  xs ? "exclaImageExtraSmall" : "exclaImage"
                                }
                              />
                            ) : (
                              <img
                                src={step5PlayButton}
                                alt="Logo"
                                className={
                                  xs ? "exclaImageExtraSmall" : "exclaImage"
                                }
                              />
                            )}
                          </Box>
                        </Box>
                      </Grid>
                    )}

                  {steps.oneShow === true && (
                    <Vendor1
                      handleChildHideCloseUp={handleChildHideCloseUp}
                      objData={objData.step1}
                      lang={pageLang}
                    />
                  )}

                  {steps.twoShow === true && (
                    <Vendor2
                      handleChildHideCloseUp={handleChildHideCloseUp}
                      objData={objData.step2}
                      lang={pageLang}
                    />
                  )}

                  {steps.threeShow === true && (
                    <Vendor3
                      handleChildHideCloseUp={handleChildHideCloseUp}
                      objData={objData.step3}
                      lang={pageLang}
                    />
                  )}
                  {steps.fourShow === true && (
                    <Vendor4
                      handleChildHideCloseUp={handleChildHideCloseUp}
                      objData={objData.step4}
                      lang={pageLang}
                    />
                  )}
                  {steps.fiveShow === true && (
                    <Vendor5
                      handleChildHideCloseUp={handleChildHideCloseUp}
                      objData={objData.step5}
                      lang={pageLang}
                    />
                  )}
                </div>
              </Grid>
            )}
          </>
        ) : (
          <Grid
            item
            xs={12}
            md={7.8}
            className="right-card"
            sx={{ backgroundColor: "#bdd8e5" }}
          >
            <div
              style={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <img
                src={IntroBg}
                style={{
                  display: "block",
                  width: "100%",
                  height: md ? "100vh" : "auto",
                  objectFit: "fill",
                }}
                alt="image"
              />

              {showIntro && (
                <Intro
                  pageLang={pageLang}
                  objData={objData?.intro}
                  buttonGoMarketElement={buttonGoMarketElement}
                />
              )}
            </div>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}

export default Quiz;
